import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, PersonalPath } from 'entities/ExportRouters'

export const AuthorizedAppsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.authorized_apps}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: `/${PersonalPath.profile}`,
        })
      }}
    />
  )
})
